import { useEffect, type ReactNode } from "react";

import { CookieBanner } from "./CookieBanner";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { captureAttribution } from "@/lib/attribution";
import { trackingLog } from "@/lib/tracking";
import { logAdClick } from "@/lib/ad-clicks.functions";

export function SiteLayout({ children }: { children: ReactNode }) {
  // Herkomst (advertentieklik, utm, verwijzer) vastleggen bij de eerste
  // paginaweergave; nodig om conversies aan Google Ads te kunnen toewijzen.
  useEffect(() => {
    const attribution = captureAttribution();
    const p = new URLSearchParams(window.location.search);
    const clickId = p.get("gclid") ?? p.get("gbraid") ?? p.get("wbraid");
    if (clickId) {
      void logAdClick({ data: { clickId, landing: window.location.pathname } }).catch(() => {});
    }
    trackingLog("paginaweergave", {
      path: window.location.pathname,
      attribution: attribution ?? "(geen herkomst bekend)",
    });
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main id="main-content" className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
